// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_V7dg9","btns-wrap":"btns-wrap_1FVBC","btn":"btn_P9-FB","on":"on_-JUWF"};